import script from "./ProductDetailsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductDetailsView.vue?vue&type=script&setup=true&lang=ts"

import "./ProductDetailsView.vue?vue&type=style&index=0&id=369ad081&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-369ad081"]])

export default __exports__